import React from 'react'
import './loader.css'

function Loader() {
  return (
    <div>
      <div class="loader"></div>
    </div>
  )
}

export default Loader
